import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import React from 'react'
import { CustomCol, FormLabels, LanguageSelector } from 'src/components'

const SaleOfferLanguageSelector: React.FC = () => {
  const { t } = useTranslation()

  return <Row>
    <CustomCol>
      <FormLabels
        title={t('settings.Language')}
        subtitle={t('SalesOffer.LanguageLabel')}
      />
    </CustomCol>
    <CustomCol>
      <LanguageSelector
        name='client_language'
        placeholder={t('SalesOffer.LanguagePlaceHolder')}
      />
    </CustomCol>
  </Row>
}

export default SaleOfferLanguageSelector
